/**
* Close an answer section residing in the FAQ on the home page
* @param {Number} val The answer section that needs to be closed
*/
function closeAnswSection(val) {
  document.getElementById(`question${val}`).classList.remove('rounded-t-lg');
  document.getElementById(`question${val}`).classList.add('rounded-lg');

  const p = document.getElementById(`para${val}`);
  const plus = document.getElementById(`plus${val}`);
  const minus = document.getElementById(`minus${val}`);

  plus.classList.remove('hidden');
  plus.classList.add('block');

  minus.classList.add('hidden');
  minus.classList.remove('block');

  p.classList.add('hidden');
  p.classList.remove('block');

  p.classList.add('exiting');
  p.classList.remove('expanded');
}

window.addEventListener('newLang', () => {
  document.getElementById('homeButton').href = `/?lang=${window.lang}`;
});

/**
 * Open the section of the question with the given number
 * This closes all other sections
 * @param {Number} val section number
 */
window.openSection = function openSection(val) {
  // Close all other sections
  const potOpen = [1, 2, 3, 4];
  const index = potOpen.indexOf(val);
  potOpen.splice(index, 1);

  potOpen.forEach((section) => closeAnswSection(section));

  // Open the section
  const p = document.getElementById(`para${val}`);
  const plus = document.getElementById(`plus${val}`);
  const minus = document.getElementById(`minus${val}`);

  [p, plus, minus].forEach((DOMElement) => {
    DOMElement.classList.toggle('hidden');
    DOMElement.classList.toggle('block');
  });

  const expanded = p.classList.contains('hidden');

  if (expanded) {
    p.classList.remove('expanded');
    p.classList.add('exiting');
  } else {
    p.classList.add('expanded');
    p.classList.remove('exiting');
  }

  document.getElementById(`question${val}`).classList.toggle('rounded-t-lg');
  document.getElementById(`question${val}`).classList.toggle('rounded-lg');
};
